export const option = {
    SDG: [{
            label: "SDG 1: No Poverty",
            value: "No Poverty"
        },
        {
            label: "SDG 2: Zero Hunger",
            value: "Zero Hunger"
        },
        {
            label: "SDG 3: Good Health and Well-being",
            value: "Good Health and Well-being"
        },
        {
            label: "SDG 4: Quality Education",
            value: "Quality Education"
        },
        {
            label: "SDG 5: Gender Equality",
            value: "Gender Equality"
        },
        {
            label: "SDG 6: Clean Water and Sanitation",
            value: "Clean Water and Sanitation"
        },
        {
            label: "SDG 7: Affordable and Clean Energy",
            value: "Affordable and Clean Energy"
        },
        {
            label: "SDG 8: Decent Work and Economic Growth",
            value: "Decent Work and Economic Growth"
        },
        {
            label: "SDG 9: Industry, Innovation and Infrastructure",
            value: "Industry, Innovation and Infrastructure"
        },
        {
            label: "SDG 10: Reduced Inequalities",
            value: "Reduced Inequalities"
        },
        {
            label: "SDG 11: Sustainable Cities and Communities",
            value: "Sustainable Cities and Communities"
        },
        {
            label: "SDG 12: Responsible Consumption and Production",
            value: "Responsible Consumption and Production"
        },
        {
            label: "SDG 13: Climate Action",
            value: "Climate Action"
        },
        {
            label: "SDG 14: Life below Water",
            value: "Life below Water"
        },
        {
            label: "SDG 15: Life on Land",
            value: "Life on Land"
        },
        {
            label: "SDG 16: Peace, Justice and Strong Institutions",
            value: "Peace, Justice and Strong Institutions"
        },
        {
            label: "SDG 17: Partnership for the Goals",
            value: "Partnership for the Goals"
        },
    ],

    EventWith:[
        "Common",
        "IIC",
        "RISE-Event"
    ],

    ProgramTheme:[
        "IPR",
        "R&D and Innovation",
        "Entrepreneurship",
        "Startup",
        "Design Thinking & Critical Thinking",
        "Incubation and Pre-Incubation",
   ],

    ProgrammType:[
        "Level 1",
        "level 2",
        "level 3",
        "level 4"
    ],

    typeOfActivity:[
        "Workshop",
        "Leadership",
        "Talk",
        "Motivational Speech",
        "Field Visit",
        "Seminar/Case Studies",
        "Exhibition/Demo Day",
        "Contest",
        "FDP",
        "Conference",
        "Techfest and Innovation",
    ],

    RegistringType:[
      "Team",
      "Individual",
      "Both"
    ],

    locationOption: [
        "Online",
        "Offline",
        "Hybrid"
    ],

    activityOption: [
        "International",
        "National",
        "State",
        "University"
    ],

    eventTypeOption: [
        "Cultural",
        "CSR",
        "Co-curriculum",
        "Sports",
        "Technical",
        "NSS"
    ],

    subEventoption: [
        "A day with the Chancellor",
        "Value Added Course",
        "Career Counseling", 
        "Corporate Counseling",
        "Corporate Training",
        "Colloquium",
        "Charity Event",
        "Commemorative day", "Communication Skills",
        "Community-Based Services as Long-Term Outreach Activities / CBR",
        "Competition",
        "Conference",
        "Development of Audio Visual / Resource Material for Public Education",
        "Early Identification / Promotion of Inclusion",
        "Enterpreneurship",
        "Environment or Green Initiative",
        "E-Sports",
        "Exhibition",
        "Exposure visit",
        "Expert Talk",
        "Extension and Outreach programs",
        "Faculty Development Program",
        "Gender Sensitization",
        "Hackathon",
        "Human Values And Ethics",
        "Industry Visit",
        "Innovation and Skill Development",
        "Meditation", "Mind Management",
        "Multilinguism",
        "Orientation",
        "Other", "Patent/IPR",
        "Pre-Placement Talks",
        "Professional Development Training Programme",
        "Seminar",
        "Sensitization / Awareness Program",
        "Skill Development Program",
        "Social Event",
        "Soft Skills",
        "Start-up",
        "Student Ambassador",
        "Summit",
        "Stustainable Development Goals",
        "Training",
        "Webinar",
        "Workshop",
        "Yoga"
    ],

    countryOption:[
        "Argentina",
        "Australia",
        "Brazil",
        "Canada",
        "China",
        "France",
        "Germany",
        "India",
        "Italy",
        "Japan",
        "Mexico",
        "Russia",
        "South Africa",
        "United Kingdom",
        "United States"
    ],

    stateOption: [
        "Other",
        "Haryana",
        "Punjab"
    ],

    templateTypeOption: [
        "Please Select ",
        "Participant",
        "Winner",
        "Coordinator",
        "Organizer",
        "Volunteer",
        "Ambassador",
        "Speaker",
        "Mentor",
        "Judge",
        "Award",
        "Achievement",
        "Completion",
        "Experience",
        "Grade",
        "Offer letter",
        "Reviewer",
        "Advisory Committee",
        "Best Paper Award",
        "Paper Presentation",
        "Best Presentation Award", 
        "Technical Program Committee",
        "Keynote Speaker",
        "Value Added Course",
        "Other"
    ],

    YesNo: [
        "Yes",
        "No"
    ],

    Fee: [
        "Free",
        "Paid"
    ],

    EventIs: [
        "Parent",
        "Child",
        "Individual"
    ],

    MemberOption: [
        "1","2","3","4","5","6","7","8","9","10",  
        "11","12","13","14","15","16","17","18","19","20",                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                     
    ],
    PO:[
        {  
            label: "PO1",
            value: "PO1"
        }, 
        {  
            label: "PO2",
            value: "PO2"
        },
        {  
            label: "PO3",
            value: "PO3"
        },
        {  
            label: "PO4",
            value: "PO4"
        },
        {  
            label: "PO5",
            value: "PO5"
        },
        {  
            label: "PO6",
            value: "PO6"
        },
        {  
            label: "PO7",
            value: "PO7"
        },
        {  
            label: "PO8",
            value: "PO8"
        },
        {  
            label: "PO9",
            value: "PO9"
        },
        {  
            label: "PO10",
            value: "PO10"
        },
        {  
            label: "PO11",
            value: "PO11"
        },
        {  
            label: "PO12",
            value: "PO12"
        }
    ],
    KeywordCharter:[
        "Educate","prepare","enthuse","empower","inculcate","foster",
        "instill","stimulate","encourage","infuse","ingrain"
    ],
    Charter:[
        {  
            label: "Let’s Educate our students for brilliant futures",
            value: "Let’s Educate our students for brilliant futures"
        },
        {  
            label: "Let’s prepare our students for Industry",
            value: "Let’s prepare our students for Industry"
        },
        {  
            label: "Let’s enthuse patriotic fervor & pride for our heritage in our students",
            value: "Let’s enthuse patriotic fervor & pride for our heritage in our students"
        },
        {  
            label: "Let’s empower our students with great communication skills",
            value: "Let’s empower our students with great communication skills"
        },
        {  
            label: "Let’s inculcate team spirit and camaraderie among our students ",
            value: "Let’s inculcate team spirit and camaraderie among our students "
        },
        {  
            label: "Let’s foster civic engagement in our students ",
            value: "Let’s foster civic engagement in our students"
        },
        {  
            label: "Let’s install discipline, integrity and honesty in our students",
            value: "Let’s install discipline, integrity and honesty in our students"
        },
        {  
            label: "Let’s stimulate scholarly energy and diligence in our students",
            value: "Let’s stimulate scholarly energy and diligence in our students"
        },
        {  
            label: "Let’s educate our students to become globally competitive",
            value: "Let’s educate our students to become globally competitive"
        },
        {  
            label: "Let’s encourage our students to think out of the box",
            value: "Let’s encourage our students to think out of the box"
        },
        {  
            label: "Let’s infuse leadership skills in our students",
            value: "Let’s infuse leadership skills in our students"
        },
        {  
            label: "Let’s ingrain spirit of entrepreneurship among our students ",
            value: "Let’s ingrain spirit of entrepreneurship among our students "
        }
    ],

    IICProgramType:[
        "Boot Camp",
        "Challenges",
        "Conference",
        "Expert Talk",
        "Exposure Visit",
        "Exhibition and Demo Day",
        "Hackathon/ Competition",   
        "Mentoring Session",
        "Seminar",
        "Techfest",
        "Workshop"
    ],

    IICCategory:[
        "Celebration Activity",
        "IIC Calendar Activity",
        "MIC Driven Activity",
        "Self-Driven Activity"
    ],


    IICLeadBy:[
        "Institute Council",
        "Student Council"
    ],

    IICTheme:[
      "Democratizing AI Resources", 
       "Economic growth and Social good",
       "Entrepreneurship and Startup",
       "Human Capital",
       "Inclusion for social Empowerment",
       "Innovation and Design Thinking",
       "Innovation & Efficiency",
       "IPR & Technology Transfer",
       "Pre-Incubation and Incubation Management",
       "Resilience",
       "Safe and Trusted AI"
    ]

};